var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Grid, Tooltip as MuiTooltip, withStyles } from '@material-ui/core';
import { Magnetic as Mi } from "../../styles";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { TooltipStyle } from './enums';
import { useState } from 'react';
import styled from '@emotion/styled';
const StyledTooltip = withStyles({
    tooltip: {
        backgroundColor: Mi.colorNeutral60,
        boxShadow: Mi.annotationBoxShadow,
        fontSize: Mi.fontSize12,
        padding: Mi.spacer12
    },
    arrow: {
        color: Mi.colorNeutral60
    }
})(MuiTooltip);
export const StyledTooltipCloseIcon = styled.span `
	padding: ${Mi.spacer04} 0 0 ${Mi.spacer20};
	font-size: ${Mi.fontSize10};
`;
/**
 * @param children content of the tooltip
 * @param tooltipStyle [Optional] TooltipStyle to open tooltip on click or hover event.
 * @param PopperProps optional property to set properties for popper container of the toolTip.
 */
export const Tooltip = (_a) => {
    var { children, tooltipStyle = TooltipStyle.HOVER, 
    /* Temporary ignored */
    /*istanbul ignore next*/
    isOpen = false, shouldTooltipCloseOnAnyEvent = false, shouldTooltipShowCloseIcon, onOpenClick, onCloseClick, getParentElement } = _a, restProps = __rest(_a, ["children", "tooltipStyle", "isOpen", "shouldTooltipCloseOnAnyEvent", "shouldTooltipShowCloseIcon", "onOpenClick", "onCloseClick", "getParentElement"]);
    const [isTooltipOpen, setIsTooltipOpen] = useState(isOpen);
    const handleTooltipOpen = () => {
        setIsTooltipOpen(true);
        if (onOpenClick) {
            onOpenClick();
        }
    };
    const handleTooltipClose = () => {
        setIsTooltipOpen(false);
        if (onCloseClick) {
            onCloseClick();
        }
    };
    React.useEffect(() => {
        shouldTooltipCloseOnAnyEvent && isTooltipOpen
            ? window.addEventListener('wheel', handleTooltipClose)
            : null;
        return () => window.removeEventListener('wheel', handleTooltipClose);
    }, [isTooltipOpen]);
    React.useEffect(() => {
        shouldTooltipCloseOnAnyEvent && isTooltipOpen
            ? window.addEventListener('keydown', handleTooltipClose)
            : null;
        return () => window.removeEventListener('keydown', handleTooltipClose);
    }, [isTooltipOpen]);
    const parentContainerOfToolTip = getParentElement ? getParentElement() : null;
    const popperProps = {
        container: parentContainerOfToolTip
    };
    const titleWithCloseIcon = (React.createElement("div", { style: { display: 'flex' } },
        React.createElement(Grid, { container: true }, restProps.title),
        React.createElement(StyledTooltipCloseIcon, { className: "mi-icon-close" })));
    if (tooltipStyle === TooltipStyle.CLICKABLE) {
        return (React.createElement(ClickAwayListener, { onClickAway: handleTooltipClose, mouseEvent: shouldTooltipCloseOnAnyEvent ? 'onMouseDown' : 'onClick', touchEvent: shouldTooltipCloseOnAnyEvent ? 'onTouchStart' : 'onTouchEnd' },
            React.createElement(StyledTooltip, Object.assign({ onClick: handleTooltipOpen, open: isTooltipOpen, arrow: true, PopperProps: popperProps }, restProps, { title: shouldTooltipShowCloseIcon ? titleWithCloseIcon : restProps.title, disableHoverListener: true, disableTouchListener: true, disableFocusListener: true }),
                React.createElement("div", null, children))));
    }
    return (React.createElement(StyledTooltip, Object.assign({ arrow: true }, restProps),
        React.createElement("div", null, children)));
};
//# sourceMappingURL=Tooltip.js.map